var _rect, _path, _line, _line2, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2,
    width: 6,
    height: 10,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10a7 7 0 0 0 14 0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 17,
    x2: 12,
    y2: 22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 22,
    x2: 16,
    y2: 22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13a1 1 0 0 1 0 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11a2 2 0 0 1 0 6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13a1 1 0 0 0 0 2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11a2 2 0 0 0 0 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattles);
export default __webpack_public_path__ + "static/media/battles.7f00173c7342865b9391a79f401f7fe0.svg";
export { ForwardRef as ReactComponent };